var _style, _defs, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaediatrics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000098203616908527056560000014549510561896871350_);}\r\n\t.st3{fill:#E86E7B;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050645257324442997940000012805086319552007343_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050645257324442997940000012805086319552007343_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.1,49.1c0-2.6-0.7-5.1-2.2-7.2c-1.4-2.1-3.4-3.8-5.8-4.8c-1.5-8.6-6-16.4-12.7-22.1c-6.7-5.6-15.2-8.7-23.9-8.7 s-17.2,3.1-23.9,8.7c-6.7,5.6-11.2,13.4-12.7,22.1c-2.7,1.1-5,3.2-6.4,5.7C7,45.4,6.6,48.4,7,51.3c0.5,2.9,1.9,5.5,4.1,7.5 c2.2,2,4.9,3.1,7.9,3.3c1.9,4.1,4.5,7.8,7.7,11c-4.7,5.1-7.6,11.5-8.4,18.3c-0.1,0.5,0,1,0.1,1.4c0.1,0.5,0.3,0.9,0.6,1.3 c0.3,0.4,0.7,0.7,1.1,1c0.4,0.2,0.9,0.4,1.4,0.5c0.1,0,0.3,0,0.4,0c0.9,0,1.8-0.3,2.5-0.9c0.7-0.6,1.1-1.4,1.2-2.3 C26.3,87,28.7,82,32.4,78c5.5,4.1,12.2,6.4,19.1,6.5c6.8-0.1,13.5-2.4,19.1-6.5c3.7,4,6.1,9,6.7,14.4c0.1,0.9,0.5,1.7,1.2,2.3 c0.7,0.6,1.5,0.9,2.5,0.9c0.1,0,0.3,0,0.4,0c1-0.1,1.9-0.6,2.5-1.4c0.6-0.8,0.9-1.8,0.7-2.7c-0.8-6.8-3.8-13.2-8.4-18.3 c3.2-3.2,5.8-6.9,7.7-11c3.3-0.2,6.4-1.7,8.6-4.1C94.9,55.6,96.1,52.4,96.1,49.1z M82.2,54.6c-0.9-0.2-1.8,0-2.5,0.4 c-0.8,0.4-1.3,1.1-1.6,2c-3.4,9.7-14.9,20-26.5,20S28.3,66.7,24.9,57c-0.3-0.8-0.9-1.5-1.6-2c-0.7-0.4-1.6-0.6-2.5-0.4 c-0.3,0.1-0.6,0.1-0.9,0.1c-1.4,0-2.7-0.5-3.7-1.5c-1-0.9-1.6-2.2-1.8-3.6c-0.1-1.4,0.3-2.8,1.1-3.9c0.8-1.1,2-1.9,3.4-2.1 c0.8-0.1,1.5-0.5,2-1.1c0.6-0.6,0.9-1.3,1-2.1c0.5-4.8,2.1-9.3,4.8-13.3c2.6-4,6.2-7.3,10.4-9.6c-0.6,2.4-0.6,4.8-0.1,7.2 c0.7,3.1,2.5,6,5,8c2.5,2.1,5.6,3.2,8.8,3.4c3.2,0.1,6.4-0.8,9.1-2.6c2.7-1.8,4.7-4.5,5.7-7.6c0.1-0.5,0.2-1.1,0.1-1.7 c-0.1-0.6-0.3-1.1-0.7-1.5c-0.3-0.5-0.8-0.8-1.3-1.1c-0.5-0.3-1.1-0.4-1.6-0.4h-0.6c-0.7,0-1.3,0.3-1.9,0.7c-0.5,0.4-0.9,1-1.1,1.7 c-0.4,1.3-1.2,2.5-2.2,3.3c-1.1,0.9-2.3,1.5-3.7,1.7c-1.4,0.2-2.8,0-4-0.5c-1.3-0.5-2.3-1.4-3.2-2.5c-0.8-1.1-1.3-2.4-1.4-3.8 c-0.1-1.4,0.2-2.7,0.8-4c0.6-1.2,1.6-2.2,2.8-3c1.2-0.7,2.5-1.1,3.9-1.1c7.4,0,14.4,2.7,19.9,7.6c5.5,4.9,8.9,11.7,9.7,19 c0.1,0.8,0.4,1.5,1,2.1c0.5,0.6,1.3,1,2,1.1c1.3,0.3,2.6,1,3.4,2.1c0.8,1.1,1.2,2.5,1.1,3.9c-0.1,1.4-0.8,2.7-1.8,3.6 c-1,0.9-2.3,1.5-3.7,1.5C82.8,54.7,82.5,54.7,82.2,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2,54.7c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6S39.1,54.7,42.2,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8,54.7c3.1,0,5.6-2.5,5.6-5.6s-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6S57.7,54.7,60.8,54.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaediatrics);
export default __webpack_public_path__ + "static/media/paediatrics.67fe44b18d2196bb4fd5d844f15f85c7.svg";
export { ForwardRef as ReactComponent };